module.exports = __webpack_public_path__ + "img/arka-plan.82b96d0a.webp";